module.exports = __webpack_public_path__ + "static/media/hannanmax.7ec6ec6e.png";